import { Component, Input } from '@angular/core';
import { LocaleComponent } from '../Locale/locale.component';

@Component({
    standalone: true,
    selector: 'app-required',
    template: '@if (show) {<span aria-hidden="true"><app-locale localeKey="REQUIRED" localeView="IFRAME" ></app-locale></span>}',
    imports: [LocaleComponent]
})
export class RequiredComponent {
  @Input() show = true;
  constructor() { }

}
